import Weaponry from "./Weaponry";
export default Weaponry;
